import * as React from "react";
import * as PropTypes from "../prop-types";
import { WizardSubstepConditions } from "@spscommerce/ds-shared";
import { usePatchReducer } from "../utils/usePatchReducer";

const propsDoc = {
  display: "string",
  condition: "WizardSubstepConditions",
  orderPosition: "string | number",
};

const propTypes = {
  ...PropTypes.spsGlobalPropTypes,
  condition: PropTypes.enumValue<WizardSubstepConditions>(WizardSubstepConditions).isRequired,
  display: PropTypes.string.isRequired,
  orderPosition: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]).isRequired,
};

export type SpsWizardSubstepProps = PropTypes.InferTS<typeof propTypes, HTMLDivElement>;

export function SpsWizardSubstep(props: SpsWizardSubstepProps) {
  const { condition = WizardSubstepConditions.BASIC, orderPosition, display, children } = props;
  const BASIC = { heading: "sps-wizard-substep__heading--basic", body: "sps-wizard-substep__body--basic" };
  const COMPLETE = { heading: "sps-wizard-substep__heading--completed", body: "sps-wizard-substep__body--completed" };
  const ACTIVE = { heading: "sps-wizard-substep__heading--active", body: "sps-wizard-substep__body--active" };

  const [state, patchState] = usePatchReducer({
    headerClasses: BASIC.heading,
    bodyClasses: BASIC.body
  });

  React.useEffect(() => {

    const conditionObj = condition === "active" ? ACTIVE :
      condition === "completed" ? COMPLETE :
        BASIC;
    patchState({
      headerClasses: conditionObj.heading,
      bodyClasses: conditionObj.body
    });

  }, [condition]);

  return (
    <div className="sps-wizard-substep">
      <div className={state.headerClasses}>
        <div className="sps-wizard-substep__heading-icon">{condition === "completed" ? (<i aria-hidden="true"
          className="sps-icon sps-icon-checkmark"></i>) : (orderPosition)}</div>
        <p>{display}</p>

      </div>
      <div className={state.bodyClasses}>
        {children}
      </div>
    </div>
  );
}

Object.assign(SpsWizardSubstep, {
  props: propsDoc,
  propTypes,
  displayName: "SpsWizardSubstep"
});
